import { useState } from "react";
import Seo from "../lib/Seo";
import useReveal from "../lib/useReveal";
import { JoinForm } from "../components/JoinForm";

const FAQS = [
  {
    q: "What is Prepare?",
    a: "A premium daily gummy being developed to support a calmer, steadier baseline. It's built for the golfer who wants less of the day still running through them when the round begins.",
  },
  {
    q: "Why is it daily, not pre-round?",
    a: "Because the pressure you carry onto the course did not start in the car park. Life happens every day, so Prepare is taken every day — the aim is a steadier baseline you bring to the round, not a switch you flip twenty minutes before the first tee.",
  },
  {
    q: "Is it a stimulant?",
    a: "No. Prepare is not a stimulant, not a pre-workout and not a miracle. Anything promising an instant transformation on the tee box is exactly what this brand is not.",
  },
  {
    q: "What's in it?",
    a: "The formulation is still in development, so we won't publish ingredient claims until they're confirmed. That's deliberate — no promises we can't stand behind. Waitlist members will see the full formulation first, with the research behind every ingredient.",
  },
  {
    q: "When does it launch?",
    a: "When it's right. Formulation and testing are under way now. The waitlist gets development updates as they happen, founding-batch access and launch information first.",
  },
  {
    q: "What does joining the waitlist get me?",
    a: "Product-development updates, founding-batch access and launch information. You'll see Prepare come together before anyone else — and have a say in it. Unsubscribe at any time.",
  },
];

const Faq = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="faq" data-testid="prepare-faq">
      {FAQS.map((f, i) => (
        <div className={`faq-item${open === i ? " open" : ""}`} key={i}>
          <button className="faq-q" onClick={() => setOpen(open === i ? null : i)} data-testid={`faq-q-${i + 1}`}>
            {f.q}
            <span className="pm">{open === i ? "–" : "+"}</span>
          </button>
          <div className="faq-a"><div className="faq-a-inner">{f.a}</div></div>
        </div>
      ))}
    </div>
  );
};

export default function Prepare() {
  useReveal();
  return (
    <>
      <Seo
        title="Prepare — The First Dialed In Product | Dialed In"
        description="Prepare is a premium daily gummy in development, built to support a calmer, steadier baseline. Join the waitlist for development updates and founding-batch access."
      />
      <section className="page-head" data-testid="prepare-page">
        <div className="wrap">
          <div className="label rv rv-up">The first product &middot; In development</div>
          <h1 className="disp page-h rv rv-up">Prepare<span className="g">.</span></h1>
          <p className="serif-line rv rv-up" style={{ marginTop: "3vh", fontSize: "clamp(20px, 2.6vw, 27px)", maxWidth: 640 }}>
            Help the golfer arrive before the round gets away from them.
          </p>
        </div>
      </section>

      <section className="sec sec-2" data-testid="prepare-what">
        <div className="wrap">
          <div className="label rv rv-up">What it is</div>
          <div className="body-copy rv rv-up" style={{ maxWidth: 640, marginTop: "4vh" }}>
            <p>Prepare is the first Dialed In product. A premium daily gummy being developed to support a calmer, steadier baseline.</p>
            <p>It's for the golfer who wants less of the day still running through them when the round begins. Because the pressure they carry onto the course did not start in the car park.</p>
            <p><strong>Life happens every day. Prepare is taken every day.</strong></p>
          </div>

          <div className="label rv rv-up" style={{ marginTop: "8vh" }}>What it is not</div>
          <div className="beats" style={{ marginTop: "3vh", maxWidth: 720 }}>
            <div className="beat rv rv-left"><span className="beat-no">01</span><span className="beat-t" style={{ fontSize: "clamp(20px, 3vw, 38px)" }}>Not a stimulant.</span></div>
            <div className="beat rv rv-right"><span className="beat-no">02</span><span className="beat-t" style={{ fontSize: "clamp(20px, 3vw, 38px)" }}>Not a pre-workout.</span></div>
            <div className="beat rv rv-left"><span className="beat-no">03</span><span className="beat-t" style={{ fontSize: "clamp(20px, 3vw, 38px)" }}>Not a miracle taken twenty minutes before the first tee.</span></div>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="prepare-status">
        <div className="wrap">
          <div className="label rv rv-up">Where it's at</div>
          <h2 className="disp sec-h rv rv-up" style={{ fontSize: "clamp(30px, 4.5vw, 60px)" }}>Currently in <span className="g">development.</span></h2>
          <div className="body-copy rv rv-up" style={{ maxWidth: 640, marginTop: "3vh" }}>
            <p>Formulation is under way. We won't make ingredient claims until the formulation is confirmed — no promises we can't stand behind.</p>
            <p>The waitlist sees everything first: the development process, the research behind each decision, founding-batch access and launch information.</p>
          </div>
        </div>
      </section>

      {/* WAITLIST */}
      <section className="sec sec-2" id="waitlist" data-testid="prepare-waitlist">
        <div className="wrap">
          <div className="join-grid">
            <div>
              <div className="label rv rv-up">The waitlist</div>
              <h2 className="disp join-h rv rv-up">Be first to <span className="g">Prepare.</span></h2>
              <p className="join-sub rv rv-up">
                Development updates as they happen. The founding batch before general release. And a real say in what this product becomes.
              </p>
            </div>
            <div className="rv rv-up">
              <JoinForm
                idPrefix="waitlist"
                tags={["DI_PREPARE_WAITLIST"]}
                buttonLabel="Join the Prepare Waitlist"
                eventName="prepare_waitlist_signup"
                consent="Join the Prepare waitlist for product-development updates, founding-batch access and launch information. Unsubscribe at any time."
                tyBody="You're on the Prepare waitlist. Development updates, founding-batch access and launch information are coming your way first."
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sec" data-testid="prepare-faq-section">
        <div className="wrap">
          <div className="label rv rv-up">Questions</div>
          <div className="rv rv-up"><Faq /></div>
        </div>
      </section>
    </>
  );
}
